import script from "./sub-device-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./sub-device-table.vue?vue&type=script&lang=ts&setup=true"

import "./sub-device-table.vue?vue&type=style&index=0&id=46cd7086&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46cd7086"]])

export default __exports__